import * as firebase from "firebase";

import {
    SETTINGS_FIELD_UPDATED,
    LANGUAGE_SWITCH,
    LANGUAGE_SWITCH_SUCCESSFUL,
    LANGUAGE_SWITCH_FAILED,
} from "./Types";

export const settingsFieldUpdated = ({ prop, value }) => {
    return {
        type: SETTINGS_FIELD_UPDATED,
        payload: { prop, value }
    }
};

export const languageSwitch = ({ english }) => {
    return(dispatch) => {
        dispatch({ type: LANGUAGE_SWITCH });
        const userID = firebase.auth().currentUser.uid;
        firebase.firestore().collection("users").doc('admins').collection(userID).doc("public").collection("account").doc("info")
            .update({ english })
            .then(() => {
                dispatch({ type: LANGUAGE_SWITCH_SUCCESSFUL });
            })
            .catch((error) => {
                dispatch({ type: LANGUAGE_SWITCH_FAILED });
                console.log(error);
            })
    };
};